<template>
<Title title="Hexaplus " />

<iframe src="https://www.hexaplus.fr" width="100%" style="border:none;height:70vh"></iframe>


</template>